import { useParams } from 'react-router-dom'

import { isPortalMode, portalContext } from 'routes/history'

export const usePortalParams = () => {
  const urlParams = useParams<{
    companyId?: string
    portalId?: string
    courseId?: string
    sectionId?: string
  }>()

  if (isPortalMode && portalContext) {
    return {
      companyId: portalContext.companyId,
      portalId: portalContext.portalId,
      courseId: urlParams.courseId,
      sectionId: urlParams.sectionId,
    }
  }

  return {
    companyId: urlParams.companyId!,
    portalId: urlParams.portalId!,
    courseId: urlParams.courseId,
    sectionId: urlParams.sectionId,
  }
}

export const usePortalBasePath = () => {
  const { companyId, portalId } = usePortalParams()

  if (isPortalMode) {
    return ''
  }

  return `/content-space/${companyId}/portal/${portalId}`
}

// V2 bundle marks window.__PORTAL_V2__ at module load (see src/portal.tsx). When
// isPortalMode is true, this flag disambiguates V2 inline player (root URLs) from
// V1 LMS (moved under /lms/*). Shared components like PortalLanding import from
// both bundles, so the branch must live in the shared helper.
export const buildCoursePath = (basePath: string, courseId: string, sectionId?: string) => {
  if (isPortalMode) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isV2 = Boolean((window as any).__PORTAL_V2__)
    const prefix = isV2 ? '' : '/lms'
    const coursePath = `${prefix}/courses/${courseId}`
    return sectionId ? `${coursePath}/sections/${sectionId}` : coursePath
  }

  const coursePath = `${basePath}/course/${courseId}`
  return sectionId ? `${coursePath}/sections/${sectionId}` : coursePath
}

export { isPortalMode }
